<div class="headline">
  <div class="responsive-nav-header">
    @if (!awaitingProtectorVersionChoice) {
      <h1 class="bolt-heading-md bolt-serif">
        {{ content.pniFirstName || 'PolicyHolder' | titlecase }}'s quote
      </h1>
    }
    @if (awaitingProtectorVersionChoice) {
      <h1 class="bolt-heading-md bolt-serif">
        Quote options
      </h1>
    }
    @if (awaitingProtectorVersionChoice) {
      <p class="bolt-body-copy-md">
        Select one to continue. The coverages you selected previously are included in each quote. You can keep customizing coverages as you continue.
      </p>
    }
    <nwx-responsive-navigation-container></nwx-responsive-navigation-container>
  </div>
</div>

@if (awaitingProtectorVersionChoice) {
  <bolt-tabset activetab="0" borderless (bolt-tab-changed)="onTabChange($event)">
    <bolt-tablabel [attr.id]="'coreQuoteTab'">
      <div class="tab-label-content">
        <div class="tab-label-title">Base Quote</div>
        @if (isNumber(content.totalPremium)) {
          <div class="tab-label-price">
            {{
            content.totalPremium | currency
            }}
          </div>
        }
        @if (!isNumber(content.totalPremium)) {
          <div class="tab-label-price">
            <nwx-passive-spinner class="flat" label="Loading"></nwx-passive-spinner>
          </div>
        }
      </div>
    </bolt-tablabel>
    <bolt-tabpanel>
      <div class="price-box-no-package">
        @for (product of content.products; track trackByProduct($index, product)) {
          <nwx-product-display
            [product]="product"
            [awaitingProtectorVersionChoice]="awaitingProtectorVersionChoice">
          </nwx-product-display>
        }
        <nwx-package-version-details [personaReport]="personaReport$ | async" [isProtectorVersionTabActive]="false"></nwx-package-version-details>
      </div>
    </bolt-tabpanel>
    <bolt-tablabel [attr.id]="'protectorQuoteTab'" [attr.disabled]="!protectorVersionLoaded ? 'true' : null">
      <div class="tab-label-content" [class.disabled-tab]="!protectorVersionLoaded">
        <img src="assets/images/icons/protector_trophy.svg" alt="Trophy" class="tab-label-icon">
        <div class="tab-label-text-content">
          <div class="tab-label-title">Protector Package Quote</div>
          @if (protectorVersionLoaded) {
            <div class="tab-label-price">
              {{
              isNumber(protectorContent.totalPremium)
              ? (protectorContent.totalPremium | currency)
              : protectorContent.totalPremium
              }}
            </div>
          }
          @if (!protectorVersionLoaded) {
            <div class="tab-label-price">
              <nwx-passive-spinner class="flat" label="Loading"></nwx-passive-spinner>
            </div>
          }
        </div>
      </div>
    </bolt-tablabel>
    <bolt-tabpanel aria-labelledby="protectorQuoteTab">
      <div class="price-box-no-package">
        @for (product of protectorContent.products; track trackByProduct($index, product)) {
          <nwx-product-display
            [product]="product"
            [awaitingProtectorVersionChoice]="awaitingProtectorVersionChoice">
          </nwx-product-display>
        }
        <nwx-package-version-details [personaReport]="protectorPackageReport" [isProtectorVersionTabActive]="true"></nwx-package-version-details>
      </div>
    </bolt-tabpanel>
  </bolt-tabset>
}

@if (!awaitingProtectorVersionChoice) {
  <div class="price-box-no-package">
    <div>
      @for (product of content.products; track trackByProduct($index, product)) {
        <nwx-product-display [product]="product"></nwx-product-display>
      }
      @if (content.upsellProducts?.length) {
        <hr />
        @for (product of content.upsellProducts; track product.type) {
          <nwx-product-display
            [product]="product"
            (addUpsell)="addUpsell.emit($event)"
          ></nwx-product-display>
        }
      }
    </div>
    @if (!content.products || content.products.length < 1) {
      <div
        id="summary-add-product"
        class="bolt-space-inner-sm bolt-background-ultralightGray"
        >
        <bolt-button
          id="summary-add-product-btn"
          type="solid"
          (click)="openProductToggleModal()"
          >Add additional products</bolt-button
          >
          Additional products will require requoting
        </div>
      }
    </div>
  }

  @if (!awaitingProtectorVersionChoice) {
    <div id="price-box-footer" class="price-box-footer">
      <nwx-price-summary-footer
        [content]="content"
        (showPdf)="showPdf.emit()"
      ></nwx-price-summary-footer>
    </div>
  }
